import {List} from "antd";
import {Link} from "react-router-dom";

export const EntityList = ({ heading, data, entityType }) => {

  return(
    <List
      className="entityList"
      header={heading !== '' ? heading : 'Others'}
      bordered
      dataSource={data}
      pagination={{
        pageSize: 10,
        showSizeChanger: false,
        hideOnSinglePage: true
      }}
      renderItem={item => <List.Item><Link to={`/${entityType}/${item}`}>{item}</Link></List.Item>}
    />
  )
}